export default __webpack_public_path__ + "static/pragicts-aws-online-presence-upgrade-ab7161c5bc4fcbb7dff5d5d6851126bc.jpg";